const RESOURCE_NAME = "entities/timeSlots";

export default {};
